module.exports = __webpack_public_path__ + "static/media/report1.a4971639.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/report1.jpg
// module id = 2058
// module chunks = 0